(function () {
function initKrsHeroQuickSearch(section) {
  if (!section) return;
    const videoEl = section.querySelector('.krs-hero-video');
    const fallbackEl = section.querySelector('.krs-hero-video-fallback');
    if (videoEl && fallbackEl) {
      videoEl.addEventListener('error', () => {
        videoEl.style.setProperty('display', 'none', 'important');
        fallbackEl.style.setProperty('z-index', '1', 'important');
      });
    }

    const form = section.querySelector('[data-krs-form]');
    const dealRadios = Array.from(section.querySelectorAll('.krs-segment-btn[data-deal]'));
    const dealSegment = section.querySelector('.krs-segment[role="radiogroup"]');
    const dealInput = section.querySelector('input[name="deal"]');
    const messageEl = section.querySelector('.krs-message');

    const searchSubmitTarget = (function () {
      var a = section.getAttribute('data-krs-search-submit');
      try { return a != null && a !== '' ? JSON.parse(a) : ''; } catch (e) { return a || ''; }
    })();
    const krsRoutesSearch = (function () {
      var a = section.getAttribute('data-krs-routes-search');
      try { return a != null && a !== '' ? JSON.parse(a) : '/search'; } catch (e) { return a || '/search'; }
    })();
    const krsFilterCollectionUrl = (function () {
      var a = section.getAttribute('data-krs-filter-collection');
      try { return a != null && a !== '' ? JSON.parse(a) : ''; } catch (e) { return a || ''; }
    })();
    const validationRangeMsg = (function () {
      var a = section.getAttribute('data-krs-val-range');
      try { return a != null && a !== '' ? JSON.parse(a) : ''; } catch (e) { return a || ''; }
    })();
    const validationBoundsMsg = (function () {
      var a = section.getAttribute('data-krs-val-bounds');
      try { return a != null && a !== '' ? JSON.parse(a) : ''; } catch (e) { return a || ''; }
    })();
    const priceMinBound = parseInt(section.getAttribute('data-krs-pb-min') || '0', 10) || 0;
    var pmaxAttr = section.getAttribute('data-krs-pb-max');
    var priceMaxBound = pmaxAttr === '__inf__' || pmaxAttr == null || pmaxAttr === '' ? Infinity : (parseInt(pmaxAttr, 10) || Infinity);

    const formatPriceDigits = (raw) => {
      const d = String(raw || '').replace(/\D/g, '');
      if (!d) return '';
      return d.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    };

    const applyPriceToInput = (input, rawValue) => {
      if (!input) return;
      const raw = String(rawValue || '').replace(/\D/g, '');
      input.dataset.raw = raw;
      input.value = raw ? formatPriceDigits(raw) : '';
    };

    const setDeal = (value) => {
      dealRadios.forEach((btn) => {
        const active = btn.dataset.deal === value;
        btn.setAttribute('aria-checked', active ? 'true' : 'false');
      });
      if (dealInput) dealInput.value = value;
    };

    const setMessage = (text) => {
      if (messageEl) messageEl.textContent = text || '';
    };

    const getPriceRaw = (input) => {
      if (!input) return '';
      return input.dataset.raw != null && input.dataset.raw !== ''
        ? input.dataset.raw
        : String(input.value || '').replace(/\D/g, '');
    };

    const mergeMode = () => form && form.dataset.krsMergeQ === 'true';
    const productsOnly = () => form && form.dataset.krsProductsOnly === 'true';
    const nativeSearchExtras = () => form && form.dataset.krsNativeSearchExtras === 'true';

    const JUNK_TOKEN = new Set(['none', 'nikoy', 'никой', 'n/a', 'na', '-', 'null']);

    const isJunkToken = (w) => {
      const s = String(w || '').trim();
      if (!s) return true;
      return JUNK_TOKEN.has(s.toLowerCase());
    };

    /** Same intent as Liquid keyword_value: drop placeholders so empty keyword does not pollute q. */
    const sanitizeKeywordInput = (raw) => {
      const s = String(raw || '').replace(/\s+/g, ' ').trim();
      if (!s) return '';
      const lc = s.toLowerCase();
      if (JUNK_TOKEN.has(lc) || lc === 'none') return '';
      return s;
    };

    /** “Всички / all”: skip narrowing city or property-type clauses. */
    const KRS_ALL_FILTER_TOKENS = new Set(['all', 'vsichki', 'всички']);

    /**
     * Shared normalization for real-estate matching (q building + optional listing haystack checks):
     * NFC, lowercase, trim, collapse whitespace, treat hyphens/underscores as spaces (slug ↔ label).
     */
    const normalizeKrsFilterText = (s) => {
      return String(s || '')
        .normalize('NFC')
        .toLowerCase()
        .replace(/[\s\-_]+/g, ' ')
        .trim()
        .replace(/\s+/g, ' ');
    };

    const isKrsWildcardLocationOrType = (valueRaw, labelRaw) => {
      const vn = normalizeKrsFilterText(valueRaw);
      const ln = normalizeKrsFilterText(labelRaw);
      return vn === '' || KRS_ALL_FILTER_TOKENS.has(vn) || (ln !== '' && KRS_ALL_FILTER_TOKENS.has(ln));
    };

    /** Escape a term for use inside double-quoted Shopify search phrases. */
    const escapeQuotedSearchPhrase = (s) => {
      return String(s || '').replace(/\\/g, '\\\\').replace(/"/g, '\\"');
    };

    const KRS_FILTER_OR_MAX_TERMS = 56;
    const KRS_FILTER_MAX_VARIANTS_PER_PHRASE = 12;

    /**
     * Slug/handle-style variants for Shopify q OR-terms (spaces / hyphens / underscores).
     */
    const searchTextDelimiterVariants = (rawOrComparable) => {
      const base = normalizeKrsFilterText(rawOrComparable);
      if (!base) return [];
      const out = [];
      const add = (v) => {
        const x = normalizeKrsFilterText(v);
        if (!x || x.length < 2 || isJunkToken(x)) return;
        if (out.length >= KRS_FILTER_MAX_VARIANTS_PER_PHRASE) return;
        if (!out.includes(x)) out.push(x);
      };
      add(base);
      const flex = base.replace(/[-_]+/g, ' ').replace(/\s+/g, ' ').trim();
      add(flex);
      const hy = flex.replace(/\s+/g, '-').replace(/-+/g, '-');
      add(hy);
      const us = flex.replace(/\s+/g, '_').replace(/_+/g, '_');
      add(us);
      const hyFromBase = base.replace(/\s+/g, '-').replace(/-+/g, '-');
      add(hyFromBase);
      const usFromBase = base.replace(/\s+/g, '_').replace(/_+/g, '_');
      add(usFromBase);
      const mixed = base.replace(/\s+/g, '-').replace(/_/g, '-').replace(/-+/g, '-');
      add(mixed);
      return out;
    };

    const pushVariantTerms = (rawPhrase, seenNorm, shopifyTerms) => {
      const n0 = normalizeKrsFilterText(rawPhrase);
      if (!n0 || isJunkToken(n0)) return;
      searchTextDelimiterVariants(n0).forEach((variant) => {
        if (shopifyTerms.length >= KRS_FILTER_OR_MAX_TERMS) return;
        if (seenNorm.has(variant)) return;
        seenNorm.add(variant);
        if (/\s/.test(variant)) {
          shopifyTerms.push(`"${escapeQuotedSearchPhrase(variant)}"`);
        } else {
          shopifyTerms.push(variant);
        }
      });
    };

    const buildShopifyOrClauseFromRawSources = (rawSources) => {
      const seenNorm = new Set();
      const terms = [];
      rawSources.forEach((raw) => {
        pushVariantTerms(raw, seenNorm, terms);
      });
      if (terms.length === 0) return '';
      if (terms.length === 1) return terms[0];
      return `(${terms.join(' OR ')})`;
    };

    const mergeUniqueRawSources = (baseList, extras) => {
      const seen = new Set();
      const out = [];
      const push = (raw) => {
        const t = String(raw || '').replace(/\s+/g, ' ').trim();
        if (!t) return;
        const k = normalizeKrsFilterText(t);
        if (!k || seen.has(k)) return;
        seen.add(k);
        out.push(t);
      };
      baseList.forEach(push);
      (extras || []).forEach(push);
      return out;
    };

    const readDatasetTrim = (opt, camelKey) => {
      try {
        if (!opt || !opt.dataset) return '';
        const v = opt.dataset[camelKey];
        return v != null && String(v).trim() !== '' ? String(v).trim() : '';
      } catch (_e) {
        return '';
      }
    };

    /**
     * City: Label|value or Label|value|country (country in data-krs-city-country). OR-clause for q.
     */
    const buildCitySearchClause = (citySel) => {
      if (!citySel || citySel.tagName !== 'SELECT' || citySel.name !== 'city') return '';
      const opt = citySel.options[citySel.selectedIndex];
      if (!opt) return '';
      const labelRaw = readDatasetTrim(opt, 'krsLabel') || String(opt.textContent || '').trim();
      const valueRaw = String(opt.value || '');
      if (isKrsWildcardLocationOrType(valueRaw, labelRaw)) return '';

      const country = readDatasetTrim(opt, 'krsCityCountry');
      const collTitle = readDatasetTrim(opt, 'krsCityCollTitle');
      const collHandle = readDatasetTrim(opt, 'krsCityCollHandle');

      const rawSources = mergeUniqueRawSources([labelRaw, valueRaw, country, collTitle, collHandle], []);
      return buildShopifyOrClauseFromRawSources(rawSources);
    };

    /**
     * Property type: Label|value|comma-keywords; optional collection title/handle from Liquid.
     */
    const buildPropertyTypeSearchClause = (ptypeSel) => {
      if (!ptypeSel || ptypeSel.tagName !== 'SELECT' || ptypeSel.name !== 'ptype') return '';
      const opt = ptypeSel.options[ptypeSel.selectedIndex];
      if (!opt) return '';
      if (opt.dataset && opt.dataset.krsPtypeAll === 'true') return '';
      if (String(opt.value || '').trim() === '') return '';

      const rawCol3 = opt.dataset && opt.dataset.krsQ != null ? String(opt.dataset.krsQ) : '';
      const labelRaw = opt.dataset && opt.dataset.krsLabel ? String(opt.dataset.krsLabel) : String(opt.textContent || '');
      const valueRaw = String(opt.value || '');
      if (isKrsWildcardLocationOrType(valueRaw, labelRaw)) return '';

      const collTitle = readDatasetTrim(opt, 'krsPtypeCollTitle');
      const collHandle = readDatasetTrim(opt, 'krsPtypeCollHandle');

      const fromComma = [];
      if (rawCol3.trim()) {
        rawCol3.split(',').forEach((piece) => {
          const t = piece.replace(/\s+/g, ' ').trim();
          if (t) fromComma.push(t);
        });
      }

      const primary = [];
      if (fromComma.length > 0) {
        primary.push(...fromComma);
      } else {
        if (labelRaw.trim()) primary.push(labelRaw.trim());
        if (valueRaw.trim()) primary.push(valueRaw.trim());
      }

      const rawSources = mergeUniqueRawSources(primary, [labelRaw, valueRaw, collTitle, collHandle]);
      return buildShopifyOrClauseFromRawSources(rawSources);
    };

    const KRS_LISTING_METAFIELD_KEYS = [
      'property_type',
      'property_subtype',
      'offer_type',
      'location',
      'city',
      'district',
      'area',
      'price',
      'construction_type',
      'floor',
      'rooms',
      'bedrooms',
      'bathrooms',
      'heating_type',
      'regulation_status',
      'road_access',
      'plot_purpose'
    ];

    const krsSafeScalar = (v) => {
      if (v == null) return '';
      if (typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean') return String(v);
      if (typeof v === 'object' && v.value != null) return krsSafeScalar(v.value);
      return '';
    };

    /**
     * One comparable string for substring checks (custom listing sections; all fields optional).
     */
    const buildKrsListingComparableHaystack = (product) => {
      try {
        if (!product || typeof product !== 'object') return '';
        const chunks = [];
        const push = (x) => {
          const s = krsSafeScalar(x).replace(/\s+/g, ' ').trim();
          if (s) chunks.push(s);
        };
        push(product.title);
        push(product.handle);
        push(product.type);
        push(product.product_type);
        push(product.vendor);
        if (Array.isArray(product.tags)) product.tags.forEach((t) => push(t));

        const cols = product.collections;
        if (Array.isArray(cols)) {
          cols.forEach((c) => {
            if (!c || typeof c !== 'object') return;
            push(c.title);
            push(c.handle);
          });
        }

        const mf = product.metafields;
        if (mf && typeof mf === 'object') {
          const custom = mf.custom && typeof mf.custom === 'object' ? mf.custom : mf;
          KRS_LISTING_METAFIELD_KEYS.forEach((k) => {
            if (Object.prototype.hasOwnProperty.call(custom, k)) push(custom[k]);
          });
        }

        return normalizeKrsFilterText(chunks.join(' '));
      } catch (_e) {
        return '';
      }
    };

    const collectComparableNeedlesFromRawList = (rawSources) => {
      const needles = [];
      const seen = new Set();
      (rawSources || []).forEach((raw) => {
        searchTextDelimiterVariants(raw).forEach((variant) => {
          const c = normalizeKrsFilterText(variant);
          if (!c || c.length < 2 || isJunkToken(c)) return;
          if (seen.has(c)) return;
          seen.add(c);
          needles.push(c);
        });
      });
      return needles;
    };

    const krsHaystackMatchesAnyNeedle = (hayComparable, needlesComparable) => {
      if (!hayComparable || !needlesComparable || !needlesComparable.length) return false;
      for (let i = 0; i < needlesComparable.length; i++) {
        const n = needlesComparable[i];
        if (n && hayComparable.indexOf(n) !== -1) return true;
      }
      return false;
    };

    const krsProductMatchesCityOption = (product, citySel) => {
      if (!citySel || citySel.name !== 'city') return true;
      const opt = citySel.options[citySel.selectedIndex];
      if (!opt) return true;
      const labelRaw = readDatasetTrim(opt, 'krsLabel') || String(opt.textContent || '').trim();
      const valueRaw = String(opt.value || '');
      if (isKrsWildcardLocationOrType(valueRaw, labelRaw)) return true;
      const country = readDatasetTrim(opt, 'krsCityCountry');
      const collTitle = readDatasetTrim(opt, 'krsCityCollTitle');
      const collHandle = readDatasetTrim(opt, 'krsCityCollHandle');
      const rawSources = mergeUniqueRawSources([labelRaw, valueRaw, country, collTitle, collHandle], []);
      const hay = buildKrsListingComparableHaystack(product);
      return krsHaystackMatchesAnyNeedle(hay, collectComparableNeedlesFromRawList(rawSources));
    };

    const krsProductMatchesPtypeOption = (product, ptypeSel) => {
      if (!ptypeSel || ptypeSel.name !== 'ptype') return true;
      const opt = ptypeSel.options[ptypeSel.selectedIndex];
      if (!opt) return true;
      if (opt.dataset && opt.dataset.krsPtypeAll === 'true') return true;
      if (String(opt.value || '').trim() === '') return true;

      const rawCol3 = opt.dataset && opt.dataset.krsQ != null ? String(opt.dataset.krsQ) : '';
      const labelRaw = opt.dataset && opt.dataset.krsLabel ? String(opt.dataset.krsLabel) : String(opt.textContent || '');
      const valueRaw = String(opt.value || '');
      if (isKrsWildcardLocationOrType(valueRaw, labelRaw)) return true;

      const collTitle = readDatasetTrim(opt, 'krsPtypeCollTitle');
      const collHandle = readDatasetTrim(opt, 'krsPtypeCollHandle');

      const fromComma = [];
      if (rawCol3.trim()) {
        rawCol3.split(',').forEach((piece) => {
          const t = piece.replace(/\s+/g, ' ').trim();
          if (t) fromComma.push(t);
        });
      }
      const primary = [];
      if (fromComma.length > 0) primary.push(...fromComma);
      else {
        if (labelRaw.trim()) primary.push(labelRaw.trim());
        if (valueRaw.trim()) primary.push(valueRaw.trim());
      }
      const rawSources = mergeUniqueRawSources(primary, [labelRaw, valueRaw, collTitle, collHandle]);
      const hay = buildKrsListingComparableHaystack(product);
      return krsHaystackMatchesAnyNeedle(hay, collectComparableNeedlesFromRawList(rawSources));
    };

    const activeDealSearchToken = (dealVal) => {
      const btn = dealRadios.find((b) => b.dataset.deal === dealVal);
      if (!btn || !btn.dataset) return '';
      const tok = btn.dataset.krsQToken;
      const raw = tok != null && String(tok).trim() !== '' ? String(tok).trim() : String(btn.dataset.krsLabel || '').trim();
      return isJunkToken(raw) ? '' : raw;
    };

    /** Normalize whitespace; dedupe case-insensitively; split chunks on spaces (deal/city/free keyword — not ptype OR-clauses). */
    const mergeTokensToQ = (chunks) => {
      const seen = new Set();
      const out = [];
      const pushWord = (w) => {
        const word = String(w || '').trim();
        if (!word || isJunkToken(word)) return;
        const k = word.toLowerCase();
        if (seen.has(k)) return;
        seen.add(k);
        out.push(word);
      };
      chunks.forEach((chunk) => {
        if (chunk == null || String(chunk).trim() === '') return;
        String(chunk)
          .replace(/\s+/g, ' ')
          .trim()
          .split(/\s+/)
          .forEach(pushWord);
      });
      return out.join(' ').trim();
    };

    const buildMergedQ = (deal, citySel, ptypeSel, keywordRaw) => {
      const dealQ = activeDealSearchToken(deal);
      const cityClause = buildCitySearchClause(citySel);
      const kw = sanitizeKeywordInput(keywordRaw);
      const ptypeClause = buildPropertyTypeSearchClause(ptypeSel);
      const rest = mergeTokensToQ([dealQ, kw]);
      const parts = [];
      if (rest) parts.push(rest);
      if (cityClause) parts.push(cityClause);
      if (ptypeClause) parts.push(ptypeClause);
      return parts.join(' ').trim();
    };

    const isPathValue = (v) => typeof v === 'string' && v.trim().startsWith('/');

    const finalizeParams = (cityRaw, ptypeRaw, params) => {
      if (isPathValue(cityRaw)) params.delete('city');
      if (isPathValue(ptypeRaw)) params.delete('ptype');
    };

    const normalizeBasePath = (raw) => {
      const s = String(raw || '').trim();
      if (!s) return krsRoutesSearch || '/search';
      if (/^https?:\/\//i.test(s)) return s;
      return s.startsWith('/') ? s : `/${s}`;
    };

    const normalizePathOnly = (u) => {
      try {
        const x = new URL(u, window.location.origin);
        return x.pathname.replace(/\/+$/, '') || '/';
      } catch (e) {
        return '';
      }
    };

    /** True for /search, /bg/search, /en/search, … (не само точно съвпадение с routes.search_url). */
    const isStorefrontSearchPathname = (pathname) => {
      const p = String(pathname || '').replace(/\/+$/, '') || '/';
      const segs = p.split('/').filter(Boolean);
      return segs.length >= 1 && segs[segs.length - 1] === 'search';
    };

    const isShopifySearchPath = (baseUrl) => {
      const raw = normalizeBasePath(baseUrl || krsRoutesSearch || '/search');
      try {
        const u = new URL(raw, window.location.origin);
        const p = u.pathname.replace(/\/+$/, '') || '/';
        const sp = normalizePathOnly(krsRoutesSearch || '/search');
        return p === sp || isStorefrontSearchPathname(p);
      } catch (e) {
        return false;
      }
    };

    const resolveNavigateBase = (baseUrl, cityRaw, ptypeRaw) => {
      if (isPathValue(cityRaw)) return cityRaw.trim().split('#')[0];
      if (isPathValue(ptypeRaw)) return ptypeRaw.trim().split('#')[0];
      return baseUrl || krsRoutesSearch || '/search';
    };

    const priceToFilterValue = (digits) => {
      const n = Number(digits);
      if (!Number.isFinite(n) || n < 0) return '';
      const major = form && form.dataset.krsPriceMajorUnits === 'true';
      const v = major ? Math.round(n) : Math.round(n * 100);
      return String(v);
    };

    const buildSearchState = () => {
      const formData = new FormData(form);
      const deal = formData.get('deal') || 'sale';
      const city = formData.get('city');
      const ptype = formData.get('ptype');
      const keyword = sanitizeKeywordInput(formData.get('q') || '');
      const priceMinInput = form.querySelector('input[name="price_min"]');
      const priceMaxInput = form.querySelector('input[name="price_max"]');
      const priceMin = getPriceRaw(priceMinInput);
      const priceMax = getPriceRaw(priceMaxInput);
      const params = new URLSearchParams();

      const citySel = form.querySelector('select[name="city"]');
      const ptypeSel = form.querySelector('select[name="ptype"]');
      const mergedQ = buildMergedQ(deal, citySel, ptypeSel, keyword);
      const filterCollectionFromDom = form && form.dataset.krsFilterCollectionUrl ? String(form.dataset.krsFilterCollectionUrl).trim() : '';
      const filterCollectionUrl = filterCollectionFromDom || (krsFilterCollectionUrl || '').trim();
      const usePriceFilters = Boolean(priceMin || priceMax);
      const useCollectionForPrice = usePriceFilters && filterCollectionUrl.length > 0;
      const submitBase = resolveNavigateBase(searchSubmitTarget, city, ptype);
      const targetIsSearch = isShopifySearchPath(submitBase) && !useCollectionForPrice;

      if (useCollectionForPrice) {
        if (mergedQ) params.set('q', mergedQ);
        const gte = priceToFilterValue(priceMin);
        const lte = priceToFilterValue(priceMax);
        if (gte) params.set('filter.v.price.gte', gte);
        if (lte) params.set('filter.v.price.lte', lte);
      } else if (targetIsSearch) {
        /* Native Shopify /search: only q (+ type, etc.) affects results — never send price_min/price_max here. */
        if (mergedQ) params.set('q', mergedQ);
        if (productsOnly()) {
          params.set('type', 'product');
          if (nativeSearchExtras()) {
            params.set('options[prefix]', 'last');
          }
        }
      } else {
        if (mergedQ) params.set('q', mergedQ);
        if (!mergeMode()) {
          params.set('deal', deal);
          if (city) params.set('city', city);
          if (ptype) params.set('ptype', ptype);
        }
        if (productsOnly() && !String(submitBase).includes('/collections/')) {
          params.set('type', 'product');
          if (nativeSearchExtras()) {
            params.set('options[prefix]', 'last');
          }
        }
        /* price_min/max are not Shopify search/collection filters unless a custom page reads them — skip on /collections/* (use collection_for_filtering + filter.v.price instead). */
        const colBrowse = String(submitBase).includes('/collections/');
        if (!colBrowse && priceMin) params.set('price_min', priceMin);
        if (!colBrowse && priceMax) params.set('price_max', priceMax);
        finalizeParams(city, ptype, params);
      }

      return {
        params,
        deal,
        city,
        ptype,
        keyword,
        priceMin,
        priceMax,
        mergedQ,
        useCollectionForPrice,
        filterCollectionUrl,
        submitBase,
        targetIsSearch
      };
    };

    const validatePrices = (priceMin, priceMax) => {
      if (priceMin && priceMax && Number(priceMin) > Number(priceMax)) {
        return validationRangeMsg;
      }
      if (priceMin) {
        const n = Number(priceMin);
        if (n < priceMinBound || n > priceMaxBound) return validationBoundsMsg;
      }
      if (priceMax) {
        const n = Number(priceMax);
        if (n < priceMinBound || n > priceMaxBound) return validationBoundsMsg;
      }
      return null;
    };

    /** Merges query onto base path; safe for /search, collections, and custom URLs. */
    const navigateWithParams = (baseUrl, params) => {
      const raw = normalizeBasePath(baseUrl || krsRoutesSearch || '/search');
      try {
        const u = new URL(raw, window.location.origin);
        const merged = new URLSearchParams(u.search);
        params.forEach((v, k) => {
          if (v !== '' && v != null) merged.set(k, v);
        });
        const qs = merged.toString();
        window.location.href = `${u.pathname}${qs ? `?${qs}` : ''}${u.hash}`;
      } catch (e) {
        const target = raw || krsRoutesSearch || '/search';
        const sep = target.includes('?') ? '&' : '?';
        const qs = params.toString();
        window.location.href = qs ? `${target}${sep}${qs}` : target;
      }
    };

    const applyFormValues = (values) => {
      if (!values || !form) return;
      Object.entries(values).forEach(([key, value]) => {
        if (value == null) return;
        const field = form.querySelector(`[name="${key}"]`);
        if (!field) return;
        if (key === 'price_min' || key === 'price_max') {
          applyPriceToInput(field, value);
          return;
        }
        /* Allow ptype '' so „Всички“ (empty option value) restores from URL/storage. */
        if (field.tagName === 'SELECT' && value === '' && key !== 'ptype') return;
        if (field.tagName === 'SELECT' || field.tagName === 'INPUT') {
          field.value = value;
        }
      });
      if (values.deal) setDeal(values.deal);
    };

    const getStored = () => {
      try {
        return JSON.parse(localStorage.getItem(`krs-qs-${section.id}`) || '{}');
      } catch (e) {
        return {};
      }
    };

    const storeValues = (values) => {
      try {
        localStorage.setItem(`krs-qs-${section.id}`, JSON.stringify(values));
      } catch (e) {
        /* no-op */
      }
    };

    /* Persist deal/city/ptype/prices only — never persist q (keyword); it caused stale tokens in merged search. */
    const PARAM_KEYS = ['deal', 'city', 'ptype', 'q', 'price_min', 'price_max'];
    const SHOPIFY_SEARCH_RESULT_TYPES = new Set(['product', 'article', 'page']);

    const stripQFromStored = (obj) => {
      if (!obj || typeof obj !== 'object') return {};
      const { q: _omit, ...rest } = obj;
      return rest;
    };

    const migrateStoredQKey = () => {
      try {
        const raw = localStorage.getItem(`krs-qs-${section.id}`);
        if (!raw) return;
        const cur = JSON.parse(raw);
        if (cur && Object.prototype.hasOwnProperty.call(cur, 'q')) {
          localStorage.setItem(`krs-qs-${section.id}`, JSON.stringify(stripQFromStored(cur)));
        }
      } catch (e) {
        /* no-op */
      }
    };

    const mergeUrlAndStorage = () => {
      const urlParams = new URLSearchParams(window.location.search);
      const merged = { ...stripQFromStored(getStored()) };
      if (urlParams.toString()) {
        PARAM_KEYS.forEach((key) => {
          if (urlParams.has(key)) {
            merged[key] = urlParams.get(key);
          }
        });
        if (!merged.ptype && urlParams.has('type')) {
          const legacy = urlParams.get('type');
          if (legacy && !SHOPIFY_SEARCH_RESULT_TYPES.has(legacy)) {
            merged.ptype = legacy;
          }
        }
      }
      return merged;
    };

    dealRadios.forEach((btn) => {
      btn.addEventListener('click', () => setDeal(btn.dataset.deal));
    });

    if (dealSegment) {
      dealSegment.addEventListener('keydown', (e) => {
        const radios = dealRadios;
        const i = radios.indexOf(document.activeElement);
        if (i < 0) return;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
          e.preventDefault();
          const next = radios[(i + 1) % radios.length];
          next.focus();
          setDeal(next.dataset.deal);
        } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
          e.preventDefault();
          const prev = radios[(i - 1 + radios.length) % radios.length];
          prev.focus();
          setDeal(prev.dataset.deal);
        }
      });
    }

    if (form) {
      const predictiveOn = form.dataset.krsPredictive === 'true';
      const predictiveSubmit = form.dataset.krsPredictiveSubmit === 'true';
      const skipPredictiveSubmit = form.dataset.krsSkipPredictiveSubmit === 'true';
      const predictiveDropdown = form.dataset.krsPredictiveDropdown === 'true';
      const predictiveMin = parseInt(form.dataset.krsPredictiveMin, 10) || 2;
      const krsShopifyRoot = (function () {
        var a = section.getAttribute('data-krs-root');
        try { return a != null && a !== '' ? JSON.parse(a) : '/'; } catch (e) { return a || '/'; }
      })();

      const fetchSuggestJson = (q) => {
        const rootFromShopify =
          typeof window !== 'undefined' && window.Shopify && window.Shopify.routes && window.Shopify.routes.root
            ? window.Shopify.routes.root
            : krsShopifyRoot;
        const base = String(rootFromShopify || '').replace(/\/+$/, '');
        const path = `${base}/search/suggest.json`;
        const sp = new URLSearchParams();
        sp.set('q', q);
        sp.set('resources[type]', 'product,collection,query');
        sp.set('resources[limit]', '10');
        sp.set('resources[limit_scope]', 'each');
        return fetch(`${path}?${sp.toString()}`).then((res) => {
          if (!res.ok) throw new Error(String(res.status));
          return res.json();
        });
      };

      const pickSuggestNavigateUrl = (json) => {
        const r = json && json.resources && json.resources.results;
        if (!r) return '';
        if (r.queries && r.queries[0] && r.queries[0].url) return r.queries[0].url;
        return '';
      };

      const escapePred = (s) => {
        const d = document.createElement('div');
        d.textContent = s == null ? '' : String(s);
        return d.innerHTML;
      };

      /**
       * suggest.json „Предложения“ връщат /search?q=… без type=product → темата показва продукти + статии + блог.
       * При включено „Само продукти“ добавяме type=product към същия storefront search path като krsRoutesSearch.
       */
      const applyProductsOnlyToSearchUrl = (href) => {
        if (!href || !productsOnly()) return href;
        try {
          const u = new URL(href, window.location.origin);
          const p = u.pathname.replace(/\/+$/, '') || '/';
          if (!isStorefrontSearchPathname(p)) return href;
          u.searchParams.set('type', 'product');
          if (nativeSearchExtras()) {
            u.searchParams.set('options[prefix]', 'last');
          }
          return `${u.pathname}${u.search}${u.hash}`;
        } catch (e) {
          return href;
        }
      };

      const tryNavigateByPredictive = (params, ctx) => {
        if (skipPredictiveSubmit || !predictiveOn || !predictiveSubmit) return Promise.resolve(false);
        if (ctx && (ctx.useCollectionForPrice || ctx.priceMin || ctx.priceMax)) return Promise.resolve(false);
        const qStr = params.get('q') || '';
        /* Do not hijack submit with suggest.json when q is empty or too short — use normal navigation. */
        if (!qStr.trim() || qStr.length < predictiveMin) return Promise.resolve(false);
        return fetchSuggestJson(qStr)
          .then((json) => {
            const url = pickSuggestNavigateUrl(json);
            if (url) {
              window.location.href = applyProductsOnlyToSearchUrl(url);
              return true;
            }
            return false;
          })
          .catch(() => false);
      };

      migrateStoredQKey();

      let initial = window.location.search ? mergeUrlAndStorage() : stripQFromStored(getStored());
      if (initial && initial.type && !initial.ptype) {
        initial = { ...initial, ptype: initial.type };
      }
      applyFormValues(initial);

      const ptypeSelect = form.querySelector('select[name="ptype"]');
      if (ptypeSelect) {
        ptypeSelect.addEventListener('change', () => {
          /* New property type: drop free-text keyword so old type words (e.g. Апартамент) cannot pollute q. */
          const qIn = form.querySelector('input[name="q"]');
          if (qIn && qIn.type !== 'hidden') qIn.value = '';
        });
      }

      const priceInputs = form.querySelectorAll('input[name="price_min"], input[name="price_max"]');
      priceInputs.forEach((input) => {
        input.addEventListener('input', () => {
          const raw = input.value.replace(/\D/g, '');
          input.dataset.raw = raw;
          if (!raw) {
            input.value = '';
            return;
          }
          input.value = raw.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        });
      });

      const runSubmit = (event) => {
        if (event) event.preventDefault();
        setMessage('');
        const {
          params,
          deal,
          city,
          ptype,
          keyword,
          priceMin,
          priceMax,
          useCollectionForPrice,
          filterCollectionUrl
        } = buildSearchState();
        const err = validatePrices(priceMin, priceMax);
        if (err) {
          setMessage(err);
          return;
        }
        storeValues({
          deal,
          city,
          ptype,
          price_min: priceMin,
          price_max: priceMax
        });
        const navBase = useCollectionForPrice ? filterCollectionUrl : resolveNavigateBase(searchSubmitTarget, city, ptype);
        tryNavigateByPredictive(params, { useCollectionForPrice, priceMin, priceMax }).then((didNav) => {
          if (didNav) return;
          navigateWithParams(navBase, params);
        });
      };

      form.addEventListener('submit', runSubmit);

      section.querySelectorAll('.krs-quick-link').forEach((link) => {
        link.addEventListener('click', (e) => {
          const { params, city: cRaw, ptype: pRaw, useCollectionForPrice, filterCollectionUrl } = buildSearchState();
          const href = link.getAttribute('href') || krsRoutesSearch || '/search';
          const base = useCollectionForPrice ? filterCollectionUrl : resolveNavigateBase(href, cRaw, pRaw);
          try {
            e.preventDefault();
            navigateWithParams(base, params);
          } catch (err) {
            /* fallback: native navigation */
          }
        });
      });

      const qInput = form.querySelector('input[name="q"]');
      const ddEl = section.querySelector('[data-krs-dropdown]');
      if (predictiveOn && predictiveDropdown && qInput && ddEl) {
        let debTimer;
        const closeDd = () => {
          ddEl.innerHTML = '';
          ddEl.hidden = true;
          ddEl.setAttribute('aria-hidden', 'true');
        };
        const renderDd = (json) => {
          const r = json && json.resources && json.resources.results;
          if (!r) {
            closeDd();
            return;
          }
          const html = [];
          if (r.queries && r.queries.length) {
            html.push('<div class="krs-predictive__group">Предложения</div>');
            r.queries.slice(0, 4).forEach((item) => {
              if (!item.url) return;
              const label = item.text || '';
              html.push(
                `<button type="button" class="krs-predictive__item" data-krs-pred-url="${encodeURIComponent(item.url)}"><span class="krs-predictive__meta"><span class="krs-predictive__title">${escapePred(
                  label
                )}</span><span class="krs-predictive__muted">Търсене</span></span></button>`
              );
            });
          }
          if (r.products && r.products.length) {
            html.push('<div class="krs-predictive__group">Продукти</div>');
            r.products.slice(0, 5).forEach((item) => {
              if (!item.url) return;
              const img = item.image
                ? `<img class="krs-predictive__thumb" src="${escapePred(item.image)}" alt="" loading="lazy" width="40" height="40" />`
                : '<span class="krs-predictive__thumb" aria-hidden="true"></span>';
              html.push(
                `<button type="button" class="krs-predictive__item" data-krs-pred-url="${encodeURIComponent(item.url)}">${img}<span class="krs-predictive__meta"><span class="krs-predictive__title">${escapePred(
                  item.title
                )}</span></span></button>`
              );
            });
          }
          if (r.collections && r.collections.length) {
            html.push('<div class="krs-predictive__group">Колекции</div>');
            r.collections.slice(0, 4).forEach((item) => {
              if (!item.url) return;
              html.push(
                `<button type="button" class="krs-predictive__item" data-krs-pred-url="${encodeURIComponent(item.url)}"><span class="krs-predictive__meta"><span class="krs-predictive__title">${escapePred(
                  item.title
                )}</span><span class="krs-predictive__muted">Колекция</span></span></button>`
              );
            });
          }
          if (!html.length) {
            closeDd();
            return;
          }
          ddEl.innerHTML = html.join('');
          ddEl.hidden = false;
          ddEl.setAttribute('aria-hidden', 'false');
        };
        qInput.addEventListener('input', () => {
          clearTimeout(debTimer);
          const v = (qInput.value || '').trim();
          if (v.length < predictiveMin) {
            closeDd();
            return;
          }
          debTimer = setTimeout(() => {
            fetchSuggestJson(v).then(renderDd).catch(() => closeDd());
          }, 280);
        });
        ddEl.addEventListener('click', (e) => {
          const b = e.target.closest('[data-krs-pred-url]');
          if (!b) return;
          e.preventDefault();
          const raw = decodeURIComponent(b.getAttribute('data-krs-pred-url'));
          window.location.href = applyProductsOnlyToSearchUrl(raw);
        });
        document.addEventListener(
          'click',
          (e) => {
            if (ddEl.hidden) return;
            const root = section.querySelector('[data-krs-predictive-root]');
            if (root && !root.contains(e.target)) closeDd();
          },
          true
        );
      }
    }

    try {
      section.krsListingFilterUtils = {
        normalizeKrsFilterText,
        buildCitySearchClause,
        buildPropertyTypeSearchClause,
        buildKrsListingComparableHaystack,
        collectComparableNeedlesFromRawList,
        krsHaystackMatchesAnyNeedle,
        krsProductMatchesCityOption,
        krsProductMatchesPtypeOption
      };
    } catch (_e) {
      /* ignore */
    }

    const media = section.querySelector('.krs-hero-media');
    const heroImage = section.querySelector('.krs-hero-image');
    if (media && heroImage) {
      let ticking = false;
      const onScroll = () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(() => {
          const rect = section.getBoundingClientRect();
          const offset = Math.min(Math.max(rect.top * -0.08, -30), 30);
          heroImage.style.setProperty('--krs-parallax', `${offset}px`);
          ticking = false;
        });
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  }

  function bootKrsHeroQuickSearch() {
    document.querySelectorAll('section.krs-hero-quick-search').forEach(initKrsHeroQuickSearch);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootKrsHeroQuickSearch);
  else bootKrsHeroQuickSearch();
})();
